module.exports = __webpack_public_path__ + "img/advocate2.deeacb73.jpg";